import { Translation } from '../../core/model/translation';

export class LettingFeatureSelection {
  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.phrase = data.phrase?.map(translation => new Translation(translation.cultureName, translation.translationText)) ?? [];
      this.isActive = data.isActive ?? true;
    }
  }

  id: string;
  phrase: Translation[] = [];
  isActive = true;
}
